<template>
  <div class="demo-app" :class="{active: this.demoActive == true}">
         <!-- <pre> {{INITIAL_EVENTS}}</pre>  -->

    <div class="flex items-start w-full">
      <!-- {{CalendarApi}} -->
      <!-- {{name}} -->
        <vs-card class="demo-app-sidebar">
          <button @click="openMenubar" class="nav-btn">
            <span class="material-icons">chevron_right</span>
          </button>
          <div class="leftSidebarContent">
            <div class="childInherit">
              <vs-input class="inputx w-full" placeholder="Search" v-model="search" />
            </div>

            <strong class="block text-lg my-4">{{ name }}</strong>
            <ul v-if="name === 'Teachers'" class="leftx name-list p-0">
              <!-- <li class="modelx">{{ name }}</li> -->
              <!-- {{radios1}} -->
              <div class="my-2">
                <vs-checkbox v-model="selectAll" @change="handleSelectedAll"><b>Select All</b></vs-checkbox>
              </div>
              <!-- {{teacherIds}} -->
              <li class="relative" v-for="(teacher, index) in teachers" :key="index">                
                <vs-checkbox :color="teacher.color" v-model="teacherIds" :vs-value="teacher.id">
                  <div class="img-holder">
                    <img 
                      src="/img/avatar-s-11.1a620230.jpg" 
                      alt="user-img" 
                      width="40" 
                      height="40" 
                      class="rounded-full shadow-md cursor-pointer block"
                    >
                  </div>
                  <span class="pl-14 inline-block">{{teacher.name}}</span>
                </vs-checkbox>
              </li>
            
            </ul>

            <ul v-else class="leftx name-list p-0">
              <!-- <li class="modelx">{{ name }}</li> -->
              <!-- {{radios1}} -->
              <div class="my-2">
                <vs-checkbox v-model="allSelected"><b>Select All</b></vs-checkbox>
              </div>
              <li class="relative" v-for="(num, index) in 10" :key="index">
                <vs-checkbox v-model="radios1[index]">
                  <div class="img-holder">
                    <img 
                      src="/img/avatar-s-11.1a620230.jpg" 
                      alt="user-img" 
                      width="40" 
                      height="40" 
                      class="rounded-full shadow-md cursor-pointer block"
                    >
                  </div>
                  <span class="pl-14 inline-block">Name {{ num }}</span></vs-checkbox
                >
              </li>
            
            </ul>
          </div>
        </vs-card>
      
        <div class="demo-app-main">
          <vs-card>
           <!-- <pre>{{arg}}</pre>  -->
            <FullCalendar
              class="demo-app-calendar"
              :options="calendarOptions"
              ref="calendar"
            >
            <!-- Hello -->
              <template v-slot:eventContent="arg">
                <div class="w-full" v-if="arg">
                 <!-- <pre>{{arg.event.extendedProps.cstmcolor}}</pre> -->
                <vs-tooltip :text="arg.event.title">
                  <!-- <div class="flex items-center p-1 event-card" :style="{backgroundColor:arg.event.backgroundColor, color:arg.event.extendedProps.cstmcolor}"> -->
                  <div class="event-card">
                    
                    <!-- <img
                      src="/img/avatar-s-11.1a620230.jpg"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md block mr-1"
                    /> -->
                    <div class="flex items-center">
                      <div class="indicator" :style="{backgroundColor: arg.event.backgroundColor}"></div>
                      <!-- <feather-icon icon="ClockIcon" /> -->
                      <b>{{ arg.timeText }}</b>
                      <!-- <feather-icon icon="UserIcon" /> -->
                      <b class="limitTitle"><i>{{ arg.event.title }}</i></b>
                      <p>
                      <i>{{arg.location}}</i>
                      </p>
                    </div>
                  </div>
                </vs-tooltip>
                  </div>

              </template>

              <!-- <template #eventContent="{ timeText, event }">
                     <pre></pre>
                    <b>{{ timeText }}</b>
                    <i>{{ event.title }}</i>
                </template> -->
            </FullCalendar>
          </vs-card>
        </div>
    </div>
    <!-- edit modal -->
    <div v-if="eachEventInfo">

      <vs-popup
        class="holamundo"
        :title="eachEventInfo.title"
        :active.sync="eachEventPopUp"
      >
        <!-- <pre>{{event}}</pre> -->
        <event-detail
        :eachEventInfo="eachEventInfo"
        ></event-detail>
        
      </vs-popup>
    </div>

    <!-- adding event modal -->
    <div v-if="eventAdding">
      <vs-popup class="holamundo" title="Add Event" :active.sync="eventAdding">
        <add-event @createEvent="createEvent"
        :startDate="startDate"
        :endDate="endDate"
        ></add-event>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import ListPlugin from '@fullcalendar/list'
import Datepicker from 'vuejs-datepicker'
import AddEvent from './components/AddEvent'
import Testing from './components/Testing'

import EventDetail from './components/EventDetail'
import Editor from '@tinymce/tinymce-vue'
import { eventMixin } from './mixins/eventMixin'
import Vue from 'vue'
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AddEvent,
    Datepicker,
    EventDetail,
    editor: Editor,
    Testing
  },
  mixins: [eventMixin],
  props: {
    name: {
      type: String,
      required: true,
      eachEventPopUp: false
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    this.radios1.fill('add', 0, 10)
    for (let i = 0; i < 10; i++) {
      
      this.radios1.push(false)
    }
  },
  // computed: {
  //   selectAll: {
  //     get () {
  //       return this.teacherIds.length === this.teachers.length
  //     },
  //     set (value) {
  //       this.teacherIds = []

  //       if (value) {
  //         this.teachers.forEach((teacher) => {
  //           this.selected.push(teacher.id)
  //         })
  //       }
  //     }
  //   }
  // },
  mounted () {
    
    // 
  
    /*    const moreElement = document.getElementsByClassName('fc-daygrid-more-link')
    

    moreElement[0].addEventListener('click', event => {
      event.stopPropagation() 
      
      // 
               
    }) */

    //inserting Component //
    const vuecomp = Vue.extend(Testing)
    const component = new vuecomp().$mount()
    
    // this.$refs.calendar.$el.firstChild.append(component.$el)


    this.$refs.calendar.$el.firstChild.parentNode.insertBefore(component.$el, this.$refs.calendar.$el.firstChild.nextSibling)


    //inserting component//
  },
  data () {
    return {
      search: 'sad',
      event: null,
      startDate:null,
      endDate:null,
      eachEventPopUp: false,
      eventAdding: false,
      title: '',
      picked: 1,
      radios1: [],
      teacherIds: [],
      selectAll: false,
      eachEventInfo:null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          ListPlugin // needed for dateClick
        ],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        eventLimit: false, // for all non-TimeGrid views
        events:INITIAL_EVENTS,
        initialView: 'dayGridMonth',
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        eventTimeFormat: { // like '14:30'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        // INITIAL_EVENTS:this.events,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      demoActive: false,
      teachers: [ 
        { 'id': '1', 'name': 'Shad Jast', 'color': 'rgb(213, 0, 0)'}, 
        { 'id': '2', 'name': 'Duane Metz', 'color': 'rgb(246, 191, 38)'}, 
        { 'id': '3', 'name': 'Myah Kris', 'color': 'rgb(63, 81, 181)'}, 
        { 'id': '4', 'name': 'Dr. Kamron Wunsch', 'color': 'rgb(11, 128, 67)'}, 
        { 'id': '5', 'name': 'Brendon Rogahn', 'color': 'rgb(231, 55, 229)'}
      ]
    }
  },
  watch: {
    teacherIds: {
      deep: true,
      handler () {
        if (this.teacherIds.length === this.teachers.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
      }
    }
  },
  methods: {
    // getContrast (hexcolor) {
    //   // 
    //   hexcolor = hexcolor.replace('#', '')
    //   const r = parseInt(hexcolor.substr(0, 2), 16)
    //   const g = parseInt(hexcolor.substr(2, 2), 16)
    //   const b = parseInt(hexcolor.substr(4, 2), 16)
    //   const yiq = (r * 299 + g * 587 + b * 114) / 1000
    //   return yiq >= 128 ? '#000000' : '#ffffff'
    // },
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {
      
      this.startDate = selectInfo.startStr
      this.endDate = selectInfo.endStr
      // 
      this.eventAdding = true
      // const title = prompt('Please enter a new title for your event')
      // const calendarApi = selectInfo.view.calendar
      // 
      // calendarApi.unselect() // clear date selection
      // if (title) {
      //   calendarApi.addEvent({
      //     id: 1,
      //     title,
      //     start: new Date().toISOString().replace(/T.*$/, ''),
      //     end: new Date().toISOString().replace(/T.*$/, ''),
      //     allDay: false
      //   })
      // }
    },
    handleEventClick (clickInfo) {
      
      this.eachEventInfo = clickInfo.event
      this.eachEventPopUp = true

      // 
      // this.event = clickInfo.event
      // 
      // const refs = this.$refs.fullCalendar.getEvents()
      // 
      // if (
      //   confirm(
      //     `Are you sure you want to delete the event '${clickInfo.event.title}'`
      //   )
      // ) {
      //   clickInfo.event.remove()
      // }
    },
    handleEvents (events) {
      this.currentEvents = events
    },
    createEvent (obj) {
      // 
      
      


      
      

      
      INITIAL_EVENTS.push({
        id: createEventId(),
        title: obj.title,
        start:`${obj.course_start} ${obj.course_start_time}`,
        // startTime: obj.course_start_time,
        end:`${obj.course_end} ${obj.course_end_time}`,
        backgroundColor: obj.eventTextColor,
        location:obj.location,
        eventTypePicked:obj.eventTypePicked
      })
      
      
      this.showSuccessMessage('Success', 'Event Added Successfully', 'success') 
      setTimeout(() => {
        this.eventAdding = false

      }, 0)
    /*   setTimeout(() => {
        this.eventAdding = false

      }, 1000) */

      // this.$refs.calendar.$emit('refetch-events')

    },
    openMenubar () {
      this.demoActive = !this.demoActive
    },
    handleSelectedAll () {
      if (this.selectAll) {
        this.teacherIds = []
        this.teacherIds = this.teachers.map((item) => item.id)
      } else {
        this.teacherIds = []
      }
    }
  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}
/* ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
} */
b {
  /* used for event dates/times */
  /* margin-right: 3px; */
}
.fc {
  /* the calendar root */
  max-width: 100%;
}
.childInherit {
  width: inherit;
}

.teacher-info {
  display: inherit;
  min-width: 50%;
  border: 1px solid #eee;
  padding: 10px;
}
.bg-light-grey {
  background: #f3f3f3;
  padding: 5px;
  margin: 0 5px;
  border-radius: 5px;
}
.tox-tinymce-aux {
  z-index: 100000 !important;
}
.event-card {
  border-radius: 4px;
  /* background-color: #41ccdf; 
  color: #fff; 
  border-width: 3px 0 0 0; 
  border-style: solid; 
  border-color: transparent; */
}
/* .fc-event-today {
  border: none;
  background-color: transparent;
}
.fc-event-today .event-card {
  background-color: #ccc;
}
.fc-event-today .indicator {
  display: none;
} */
.event-card .feather-icon {
  width: 12px;
  margin-right: 2px;
}
.event-card .limitTitle {
  display: inline-block;
  width: calc(100% - 45px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.indicator {
  width: 7px;
  height: 7px;
  margin-right: 3px;
  border-radius: 50%;
}

/* td.fc-daygrid-day {
  height: 200px;
} */

@media (max-width: 480px) {
  .teacher-info {
    min-width: 100%;
  }
}
</style>

